export default __webpack_public_path__ + "static/media/dot.657b67be.svg";